import {
  loadPlan,
  loadPracticeTemplates,
  normalizePlan,
  replacePracticeTemplates,
  savePlan,
  type PracticePlan,
} from "./practice-storage";
import { cloudWorkspaceHeaders } from "./cloud-drill-storage";

const API = "/api/coach-practice-plans";

export async function syncPracticePlan() {
  const local = loadPlan();
  try {
    const response = await fetch(API, {
      headers: await cloudWorkspaceHeaders(),
    });
    if (!response.ok) throw new Error(`Cloud load returned ${response.status}`);
    const body = (await response.json()) as { plans?: PracticePlan[] };
    const remote = Array.isArray(body.plans)
      ? body.plans.map(normalizePlan)
      : [];
    const remoteCurrent = remote.filter(
      (plan) => plan.id === "current-practice",
    );
    const latest = remoteCurrent.reduce(
      (current, plan) => (plan.updatedAt > current.updatedAt ? plan : current),
      local,
    );
    const templates = new Map(
      [
        ...loadPracticeTemplates(),
        ...remote.filter((plan) => plan.id !== "current-practice"),
      ]
        .sort((a, b) => a.updatedAt.localeCompare(b.updatedAt))
        .map((plan) => [plan.id, plan]),
    );
    savePlan(latest);
    replacePracticeTemplates([...templates.values()]);
    await saveCloudPracticePlan(latest);
    return { plan: latest, synced: true };
  } catch {
    return { plan: local, synced: false };
  }
}

export async function deleteCloudPracticePlan(id: string) {
  try {
    const response = await fetch(`${API}?id=${encodeURIComponent(id)}`, {
      method: "DELETE",
      headers: await cloudWorkspaceHeaders(),
    });
    return response.ok;
  } catch {
    return false;
  }
}

export async function saveCloudPracticePlan(plan: PracticePlan) {
  try {
    const response = await fetch(API, {
      method: "POST",
      headers: await cloudWorkspaceHeaders(),
      body: JSON.stringify({ plans: [plan] }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
